export const FLAG_FORM_ID = 'flag-form';
export const MONEY_SEPARATOR = ',';

export const PIP_PROCESS_DOC_URL =
  'https://docs.google.com/document/d/10Z12alnsaziF7rdq0D76E2Lhh_UVV4oXG_7MvM4VLhs/edit?usp=sharing';
export const PIP_TEMPLATE_DOC_URL =
  'https://docs.google.com/spreadsheets/d/1-xgB62egZGsjOwb1z0uYXutZ6KyldtuVFohexmzUVF8/edit?usp=sharing';

export const compensationCompetitivenessOptions = [
  {
    value: 'lowerThanAE',
    description: 'Lower than AE’s',
  },
  {
    value: 'equalThanAE',
    description: 'Equal to AE’s',
  },
  {
    value: 'higherThanAE',
    description: 'Higher than AE’s',
  },
];

export const offerAcceptanceStatusOptions = [
  {
    value: 'pending',
    description: 'Pending',
  },
  {
    value: 'accepted',
    description: 'Accepted',
  },
  {
    value: 'rejected',
    description: 'Rejected',
  },
];
